import { useSyncExternalStore } from 'react';

// Only the mounted, authenticated Product Guide registers an opener. Tickets are
// invalidated on route, account, auth or mount changes; this grants no permissions.
let current = null;
const listeners = new Set();
const emit = () => listeners.forEach(listener => listener());
const subscribe = listener => { listeners.add(listener); return () => listeners.delete(listener); };
const snapshot = () => current?.pathname ?? null;
const serverSnapshot = () => null;

export function registerProductGuide({ pathname, open }) {
  const owner = { pathname, open };
  current = owner;
  emit();
  return () => { if (current === owner) { current = null; emit(); } };
}

export function useProductGuideAvailable(pathname) {
  return useSyncExternalStore(subscribe, snapshot, serverSnapshot) === pathname;
}

export function prepareProductGuideOpening(pathname) {
  const owner = current;
  if (!owner || owner.pathname !== pathname) return null;
  return () => current === owner && owner.open();
}
